import { io } from "socket.io-client";

const ENDPOINT = process.env.REACT_APP_BACKEND_SERVER_URL || window.location.origin;

const socket = io(ENDPOINT, {
  transports: ["websocket", "polling"],  // Added polling as fallback
  withCredentials: true,
  autoConnect: false,
  secure: window.location.protocol === "https:",
  reconnection: true,           // Enable reconnection
  reconnectionAttempts: 5,      // Try to reconnect 5 times
  reconnectionDelay: 1000,      // Wait 1 second before reconnect
});

// Add connection event listeners for debugging
socket.on("connect", () => {
  console.log("Socket connected:", socket.id);
});

socket.on("disconnect", (reason) => {
  console.log("Socket disconnected:", reason);
});

socket.on("connect_error", (error) => {
  console.log("Connection error:", error);
});

export default socket;
